import { IntlShape } from 'react-intl'
import { NewDropoffOpenCloseTime, NewDropoffOpeningHours } from "../../domain/models/NewDropoff"

const days = [
    'Day.medium.sunday',
    'Day.medium.monday',
    'Day.medium.tuesday',
    'Day.medium.wednesday',
    'Day.medium.thursday',
    'Day.medium.friday',
    'Day.medium.saturday'
]

const openingHoursToString: (value: NewDropoffOpeningHours | undefined, intl: IntlShape) => string = (value, intl) => {
    if (!value || value.daysOfWeek.length === 0) {
        // Placeholder
        return intl.formatMessage({id: 'SubmitDropoff.contact.opening.hours.placeholder'})
    }
    
    let openedDaysText = ''
    let closedDaysText = ''

    let openedStartIndex: number | undefined
    let closedStartIndex: number | undefined

    for (let i=0; i<7; i++) {
        if (value.daysOfWeek.includes(i)) {
            // Opened
            if (closedStartIndex !== undefined) {
                // Was closed before, add the series to text
                closedDaysText = daysString(closedStartIndex, i - 1, closedDaysText, intl)
                closedStartIndex = undefined
            }
            if (openedStartIndex === undefined) {
                // New closed days series
                openedStartIndex = i
            }
        } else {
            // Closed
            if (openedStartIndex !== undefined) {
                // Was opened before, add the series to text
                openedDaysText = daysString(openedStartIndex, i - 1, openedDaysText, intl)
                openedStartIndex = undefined
            }
            
            if (closedStartIndex === undefined) {
                // First closed day
                closedStartIndex = i
            }
        }
        if (i === 6) {
            if (openedStartIndex !== undefined) {
                openedDaysText = daysString(openedStartIndex, i, openedDaysText, intl)
            }
            if (closedStartIndex !== undefined) {
                closedDaysText = daysString(closedStartIndex, i, closedDaysText, intl)
            }
        }
    }
    
    if (value.isOpenAllDay) {
        openedDaysText += ' : '
        openedDaysText += intl.formatMessage({id: 'SubmitDropoff.contact.all.day'})
    } else if (value.openCloseTimes.length > 0) {
        openedDaysText += ' : '
        let hoursText = ''
        value.openCloseTimes.forEach((times) => {
            if (hoursText.length > 0) {
                hoursText += ', '
            }
            hoursText += timeString(times, intl)
        })
        openedDaysText += hoursText
    }

    closedDaysText += ' : '
    closedDaysText += intl.formatMessage({id: 'SubmitDropoff.contact.closed'})


    let text = openedDaysText + ', ' + closedDaysText
    return text
}

const daysString: (startIndex: number, endIndex: number, appending: string, intl: IntlShape) => string = (startIndex, endIndex, appending, intl) => {
    let text = ''
    if (appending.length > 0) {
        appending += ', '
    }
    // Add previous days to opened string
    if (startIndex === endIndex) {
        // Single day
        text += intl.formatMessage({id: days[startIndex]})
    } else {
        // Multiple days
        text += intl.formatMessage({id: days[startIndex]})
        text += ' - '
        text += intl.formatMessage({id: days[endIndex]})
    }
    
    return appending + text
}

const timeString: (value: NewDropoffOpenCloseTime, intl: IntlShape) => string = (value, intl) => {
    return value.openTime + ' - ' + value.closeTime
}

export {
    openingHoursToString
}
